// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__gbSax","a":"style_a__2TR0l","h4":"style_h4__1xkiV","footerDash":"style_footerDash__19eRp","h3Dash":"style_h3Dash__1Bwzv"};